import { useMemo } from "react";
import { Dispatch, AnyAction } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store/RootReducers";
import { UpdateProfileRequest, UserConsentObject } from "../../services/profileService/ProfileService.type";
import { profileActions } from "../../store/profile/actions";
import { ProfileState } from "../../store/profile/state";

interface Selectors {
  profileState: ProfileState;
}
interface ActionDispatchers {
  updateProfile: (payload: UpdateProfileRequest) => void;
  giveBorrowerConsent: () => void;
  removeBorrowerConsent: () => void;
}

/**
 * @description accesses Redux, returns required state,actions
 *
 * @returns {(Selectors & ActionDispatchers)}
 */
const useProfile = (): Selectors & ActionDispatchers => {
  const dispatch = useDispatch<Dispatch<AnyAction>>();
  const selectors = useSelector(stateSelector);
  const actionDispatchers = useMemo(() => actions(dispatch), [dispatch]);

  return { ...selectors, ...actionDispatchers };
};

const stateSelector = (state: ApplicationState): Selectors => ({
  profileState: state.profileState
});

const actions = (dispatch: Dispatch<AnyAction>): ActionDispatchers => ({
  updateProfile: (data: UpdateProfileRequest) => {
    dispatch(profileActions.updateProfile.started(data));
  },
  giveBorrowerConsent: () => {
    const data = {user_source:"CUSTOMER-PORTAL",is_download_credit_bureau_report:"Y",is_download_otp_data:"Y"} as UserConsentObject
    dispatch(profileActions.setBorrowerConsent.started(data))
  },
  removeBorrowerConsent:() => {
    const data = {user_source:"CUSTOMER-PORTAL",is_download_credit_bureau_report:"N",is_download_otp_data:"N"} as UserConsentObject
    dispatch(profileActions.setBorrowerConsent.started(data))
  }
});

export default useProfile;
